import { render } from "./PersonOrderView.vue?vue&type=template&id=2bf11592&scoped=true"
import script from "./PersonOrderView.vue?vue&type=script&lang=js"
export * from "./PersonOrderView.vue?vue&type=script&lang=js"

import "./PersonOrderView.vue?vue&type=style&index=0&id=2bf11592&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf11592"]])

export default __exports__